import React from 'react'
import { motion } from 'framer-motion'
import { useAuth } from '../../contexts/AuthContext'
import SafeIcon from '../../common/SafeIcon'
import * as FiIcons from 'react-icons/fi'

const { FiBookOpen, FiArrowRight } = FiIcons

const BookCard = ({ book, onClick, isLoading }) => {
  const { user } = useAuth()

  const getStatusColor = () => {
    if (book.isAvailable) return 'text-dark_cyan bg-dark_cyan-900 border-dark_cyan-800'
    return 'text-hot_berry bg-hot_berry-900 border-hot_berry-800'
  }

  return (
    <motion.div 
      layout
      whileHover={{ y: -8 }}
      onClick={() => onClick(book)}
      className="bg-white rounded-3xl shadow-sm border-2 border-white-400 overflow-hidden group flex flex-col h-full relative cursor-pointer"
    >
      <div className="aspect-[3/4] bg-white-500 flex items-center justify-center overflow-hidden relative">
        {book.cover_image ? (
          <img 
            src={book.cover_image} 
            alt={book.title} 
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
          />
        ) : (
          <SafeIcon icon={FiBookOpen} className="w-12 h-12 text-white-400" />
        )}
        
        {/* Status Badge - Privacy Protected */}
        <div className="absolute top-3 right-3">
          <span className={`inline-flex items-center px-2 py-1 rounded-xl text-[8px] font-black uppercase tracking-[0.15em] border-2 backdrop-blur-md ${getStatusColor()}`}>
            {book.isAvailable ? 'In' : 'Out'}
          </span>
        </div>
      </div>

      <div className="p-5 flex flex-col flex-1">
        <div className="flex-1 min-h-0">
          <h3 className="font-black text-space_indigo uppercase text-sm leading-tight group-hover:text-dark_cyan transition-colors mb-2 line-clamp-2">
            {book.title}
          </h3>
          <p className="text-[10px] font-black text-white-300 uppercase tracking-widest mb-4 truncate italic">
            {book.author}
          </p>
        </div>

        <div className="flex items-center justify-between mt-2 pt-4 border-t border-white-500">
          <span className="text-[9px] font-black text-white-400 uppercase tracking-widest">
            {book.category}
          </span>
          <div className="w-8 h-8 rounded-full bg-white-500 border border-white-400 flex items-center justify-center group-hover:bg-dark_cyan group-hover:border-dark_cyan transition-all">
            <SafeIcon icon={FiArrowRight} className="w-3.5 h-3.5 text-white-300 group-hover:text-white transition-colors" />
          </div>
        </div>
      </div>
    </motion.div>
  )
}

export default BookCard